import { render, staticRenderFns } from "./DashboardViewCollection.vue?vue&type=template&id=bf65862a&scoped=true&"
import script from "./DashboardViewCollection.ts?vue&type=script&lang=ts&"
export * from "./DashboardViewCollection.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardViewCollection.scss?vue&type=style&index=0&id=bf65862a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf65862a",
  null
  
)

export default component.exports